import { useHistory, useLocation, useParams } from 'react-router-dom';
import { jobOpeningDetailsTabs, jobOpeningPages } from '../../../../utils/types/JobOpenings';

export const useJobOpeningNavigation = () => {
  const history = useHistory();
  const location = useLocation();
  const { id } = useParams<{ id: string }>();

  // Determine current tab from URL path
  const getCurrentPage = (): jobOpeningPages => {
    const path = location.pathname;
    if (path.includes('/details')) return 'Job Opening Details';
    if (path.includes('/analysis')) return 'Applicant Analysis';
    if (path.includes('/assessments')) return 'Auto-Assessments';
    if (path.includes('/interviews')) return 'Smart Interviews';
    if (path.includes('/analytics')) return 'Analytics';
    if (path.includes('/psychometric')) return 'Psychometric';
    if (path.includes('/wellness')) return 'Wellness';
    return 'Job Opening Details';
  };

  // Determine current sub-tab from URL path (for Details)
  const getCurrentSubTab = (): jobOpeningDetailsTabs => {
    const path = location.pathname;
    if (path.includes('/requisition')) return 'Job Requisition';
    if (path.includes('/description')) return 'Job Description';
    if (path.includes('/suitability')) return 'Auto Suitability';
    if (path.includes('/outstanding')) return 'Auto Outstanding';
    if (path.includes('/assess-config')) return 'Auto Assess Questions';
    if (path.includes('/posting')) return 'Job Posting';
    if (path.includes('/ingestion')) return 'CV Ingestion';
    if (path.includes('/permissions')) return 'Permissions';
    return 'Job Requisition';
  };

  const navigateToTab = (page: jobOpeningPages) => {
    let subPath = '';
    switch (page) {
      case 'Job Opening Details': subPath = 'details/requisition'; break;
      case 'Applicant Analysis': subPath = 'analysis'; break;
      case 'Auto-Assessments': subPath = 'assessments'; break;
      case 'Smart Interviews': subPath = 'interviews'; break;
      case 'Psychometric': subPath = 'psychometric'; break;
      case 'Analytics': subPath = 'analytics'; break;
      case 'Wellness': subPath = 'wellness'; break;
    }
    const basePath = id ? `/job-openings/${id}` : '/job-openings/create';
    history.push(`${basePath}/${subPath}`);
  };

  const navigateToSubTab = (subTab: jobOpeningDetailsTabs) => {
    let subPath = '';
    switch (subTab) {
      case 'Job Requisition': subPath = 'requisition'; break;
      case 'Job Description': subPath = 'description'; break;
      case 'Auto Suitability': subPath = 'suitability'; break;
      case 'Auto Outstanding': subPath = 'outstanding'; break;
      case 'Auto Assess Questions': subPath = 'assess-config'; break;
      case 'Job Posting': subPath = 'posting'; break;
      case 'CV Ingestion': subPath = 'ingestion'; break;
      case 'Permissions': subPath = 'permissions'; break;
    }
    const basePath = id ? `/job-openings/${id}` : '/job-openings/create';
    history.push(`${basePath}/details/${subPath}`);
  };

  return {
    currentPage: getCurrentPage(),
    currentSubTab: getCurrentSubTab(),
    navigateToTab,
    navigateToSubTab,
  };
};
